/*eslint no-magic-numbers: ["error", { "ignore": [0,1,2, -1] }]*/
/* eslint-disable */
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import capitalizeString from 'utils/capitalize'
import ActionsMenu from 'features/ActionMenu'
import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import AssessmentIcon from 'assets/icons/assessments-icon'
import { ProfileContext } from 'providers/profile'
import siteStatuses, { SITE_STATUS_CONFIRMED_ID, SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID, SITE_STATUS_REVIEWED_BY_RFP_ID, SITE_STATUS_SUPERSEDED_ID, SITE_STATUS_DELISTED_ID, SITE_STATUS_DOES_NOT_QUALIFY, SITE_STATUS_PROPOSED_ID, SITE_STATUS_NOMINATED_ID } from 'constants/siteStatuses'
import { siteTableActionMenuItems } from 'constants/siteTableActionMenuItems'
import Tooltip from 'components/Tooltip'
import { CountriesContext } from 'providers/countries'
import { SortingArrowWrapper } from 'components/SortingArrow/style'
import { SitesModalContext } from 'providers/sitesProviders'
import { useIBAAccess } from 'hooks/useIBAAccess'
import { INDIVIDUAL_ROLE_ID, NCG_ROLE_ID, RFP_ROLE_ID, SECRETARIAT_ROLE_ID, BIRDLIFE_SECRETARIAT_ROLE_ID, BRC_ROLE_ID } from 'constants/roles'

import {
  SitesTableIconConfirmed, SitesTableIconDelistedWrapper,
  SitesTableUnderAssessmentIcon,
  SitesTableIconDraft,
  SitesTableIconNominated,
  SitesTableIconProposed,
  SitesTableIconReviewedRFP,
  SitesTableIconSuperseded,
  SiteTableCountryContainer,
  SiteTableIconDelisted,
  SitesTableIconsWrapper,
  SiteTableAssessmentIcon, SiteFilterValueWrapper, SitesTableIconNotQualifyWrapper,
  SitesTableIconEditOnly,
  SitesTableIconEditOnlyWrapper,
  SitesTableIconProposedEditOnlyWrapper
} from './style'
import { MySiteContext } from 'providers/mySiteProvider'

export const renderSitesStatusIcon = (status) => {
  if (status === '-') {
    return
  }

  const statusIcon = {
    draft: <SitesTableIconDraft />,
    editOnly: <SitesTableIconEditOnly />,
    proposed: <SitesTableIconProposed />,
    'reviewed by rfp': <SitesTableIconReviewedRFP />,
    nominated: <SitesTableIconNominated />,
    confirmed: <SitesTableIconConfirmed />,
    superseded: <SitesTableIconSuperseded />,
    delisted: <SitesTableIconDelistedWrapper>
      <SiteTableIconDelisted />
    </SitesTableIconDelistedWrapper>,
    'does not qualify': <SitesTableIconNotQualifyWrapper />,
    'confirmedEditOnly': <SitesTableIconEditOnlyWrapper />,
  }

  return statusIcon[status]
}

export const renderSitesStatusUnderAssessment = (status) => {
  if (status === '-') {
    return
  }

  const statusIcon = {
    Draft:
      <>
        <SitesTableUnderAssessmentIcon />
        <span>Under assessment</span>
      </>,
    Proposed:
      <>
        <SitesTableUnderAssessmentIcon />
        <span>Under assessment</span>
      </>,
    'Reviewed by rfp':
      <>
        <SitesTableUnderAssessmentIcon />
        <span>Under assessment</span>
      </>,
    Nominated:
      <>
        <SitesTableUnderAssessmentIcon />
        <span>Under assessment</span>
      </>,
    Confirmed:
      <>
        <SitesTableIconConfirmed />
        <span>Confirmed</span>
      </>,
    Superseded:
      <>
        <SitesTableIconSuperseded />
        <span>Superseded</span>
      </>,
    Delisted:
      <>
        <SitesTableIconDelistedWrapper>
          <SiteTableIconDelisted />
        </SitesTableIconDelistedWrapper>
        <span>Delisted</span>
      </>,
    'Does not Qualify':
      <SiteFilterValueWrapper>
        <SitesTableIconNotQualifyWrapper />
        Does not Qualify
      </SiteFilterValueWrapper>,
    'Edit Only':
      <>
        <SitesTableIconEditOnly />
        <span>Edit only</span>
      </>,
    'Submitted Edits':
      <>
        <SitesTableIconProposedEditOnlyWrapper />
        <span>Edits submitted</span>
      </>,
  }

  return statusIcon[status]
}

const tooltipXOffset = 0
const tooltipYOffset = -16
const tooltipYOffsetAssessment = -15

// Tooltip character limits
const SITE_NAME_MAX_LENGTH = 15
const PROPOSER_MAX_LENGTH = 12
const DEFAULT_MAX_LENGTH = 30

const renderWithTooltip = (text, maxLength = DEFAULT_MAX_LENGTH) => {
  if (!text || text.length <= maxLength) {
    return text
  }

  return (
    <Tooltip
      style={{ zIndex: 1000 }}
      placement='top'
      trigger={['hover']}
      align={{ offset: [tooltipXOffset, tooltipYOffset] }}
      overlay={{ label: text }}
      zIndex="9999"
    >
      <div style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '200px',
        display: 'inline-block'
      }}>
        {text}
      </div>
    </Tooltip>
  )
}

const displayCountry = (countryArray) => {
  const { countriesOptions } = useContext(CountriesContext)
  if (!countryArray) {
    return ''
  }
  const formattedArray = countryArray.map((item) => {
    const country = countriesOptions.find((element) => {
      return element.value === item
    })
    return country?.label
  }).filter(Boolean) // Remove undefined values

  if (countryArray.length > 2) {
    return (
      <SiteTableCountryContainer>
        <Tooltip
          style={{ zIndex: 1000 }}
          placement='top'
          trigger={['hover']}
          align={{ offset: [tooltipXOffset, tooltipYOffset] }}
          overlay={{ label: formattedArray.join(', ') }}
          zIndex="9999"
        >
          <div>
            {formattedArray.slice(0, 2).join(', ')}...
          </div>
        </Tooltip>
      </SiteTableCountryContainer>
    )
  }
  return formattedArray.join(', ')
}

function getSiteStatusName(siteStatusId) {
  const status = siteStatuses.find((statusItem) => statusItem.id == siteStatusId);
  return status ? status.name : 'Unknown';
}

export const makeSitesRows = (sites = [], setSiteToWorkWith, setSiteToReject, setSiteToPublish, setSiteToDelist, showReassessmentListModal, isMySite, setSiteForDeleting, setIsSiteDoesNotQualified, setSiteIsModalEditOpen, approveEditOnlyCallBack, setEditOnlySiteToReject) => {
  const { toggleModal, setSite } = useContext(SitesModalContext)
  const { setIsLoading } = useContext(MySiteContext)
  const { profile } = useContext(ProfileContext)
  const history = useNavigate()
  
  // Check if user has IBA access using the new hook
  const { canSeeSiteIBASitesManagement, shouldShowSiteIBAData } = useIBAAccess()

  if (profile.id) {
    if (!Array.isArray(sites)) {
      setIsLoading(false);
      return []
    }

    const sitesNumber = sites.length;
    let countSites = 0;
    return sites.map((site) => {
      const dropItemsProps = {
        [INDIVIDUAL_ROLE_ID]: [site, profile, history, setSiteToWorkWith, setSiteForDeleting, toggleModal, setSite, setSiteIsModalEditOpen, setEditOnlySiteToReject],
        [NCG_ROLE_ID]: [site, profile, history, setSiteToWorkWith, setSiteForDeleting, toggleModal, setSite],
        [RFP_ROLE_ID]: [site, history, setSiteToWorkWith, setSiteToReject, toggleModal, setSite, approveEditOnlyCallBack],
        [SECRETARIAT_ROLE_ID]: [site, history, setSiteToWorkWith, setSiteToPublish, setSiteToDelist, setIsSiteDoesNotQualified, setSiteForDeleting, toggleModal, setSite, approveEditOnlyCallBack, profile],
        [BIRDLIFE_SECRETARIAT_ROLE_ID]: [site, history, setSiteToWorkWith, setSiteToPublish, setSiteToDelist, setIsSiteDoesNotQualified, setSiteForDeleting, toggleModal, setSite, approveEditOnlyCallBack, profile],
        [BRC_ROLE_ID]: [site, history, setSiteToWorkWith, setSiteToReject, toggleModal, setSite, approveEditOnlyCallBack],
      }

      const dropdownItems = siteTableActionMenuItems[profile.RoleId](...dropItemsProps[profile.RoleId])

      const siteStatus = site.SiteStatus
      const kbaAssessmentStatus = site.reassessmentFlag ? site.Site.SiteStatus : site.SiteStatus

      countSites++;
      if (countSites === sitesNumber) {
        setIsLoading(false);
      }

      // Row-level IBA visibility is driven by per-site access flag
      const hasIBAAccessForRow = Boolean(site?.ibaAccess?.hasAccess)

      return isMySite ? {
        id: site.id,
        historyId: site.historyId,
        siteStatusId: site.SiteStatus?.id,
        country: displayCountry(site.SiteDetailsCountryId),
        siteId: site.siteCode,
        siteName: renderWithTooltip(site.name, SITE_NAME_MAX_LENGTH),
        year: site.year,
        proposer: renderWithTooltip(site.User ? `${capitalizeString(site.User.lastName || '')} ${capitalizeString(site.User.firstName || '')}` : 'Unknown', PROPOSER_MAX_LENGTH),
        siteStatus: (
          <>
            {kbaAssessmentStatus && renderSitesStatusUnderAssessment(getSiteStatusName(kbaAssessmentStatus.id))}
          </>
        ),
        siteCriteria: (site.siteCriterias && site.siteCriterias.length > 0) ? site.siteCriterias.sort((a, b) => {
          if (a < b) {
            return -1
          }
          if (a > b) {
            return 1
          }

          return 0
        }).join(', ') : '-',
        assessment: (
          <>
            {(siteStatus && siteStatus.id !== SITE_STATUS_SUPERSEDED_ID) && renderSitesStatusIcon(siteStatus.name)}
            {(siteStatus && siteStatus.id === SITE_STATUS_REVIEWED_BY_RFP_ID && siteStatus.name !== '-')
              ? 'Reviewed by RFP'
              : (siteStatus && siteStatus.id === SITE_STATUS_SUPERSEDED_ID) ? '-'
                : (siteStatus && siteStatus.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID) ? renderSitesStatusUnderAssessment(getSiteStatusName(siteStatus.id))
                  : (siteStatus && siteStatus.id === SITE_STATUS_EDIT_ONLY_ID) ? renderSitesStatusUnderAssessment(getSiteStatusName(siteStatus.id)) : (siteStatus ? capitalizeString(siteStatus.name) : '-')}
          </>
        ),
        ibaStatus: hasIBAAccessForRow
          ? renderSitesStatusUnderAssessment(
            shouldShowSiteIBAData(site, site.IbaStatus?.id || site.IbaStatusHistory?.id, 'sitesManagement')
          )
          : null,
        ibaCriteria: hasIBAAccessForRow ? shouldShowSiteIBAData(site, site.ibaCriterias && site.ibaCriterias.length > 0 ? site.ibaCriterias.sort((a, b) => {
            if (a < b) {
              return -1
            }
            if (a > b) {
              return 1
            }
            return 0
          }).join(', ') : null,
          'sitesManagement'
        ) : null,
        actions: (
          <SitesTableIconsWrapper>
            <div style={{ width: '24px' }}>
              {(siteStatus && site.SitesHistories && siteStatus.id === SITE_STATUS_CONFIRMED_ID) && (
                <SiteTableAssessmentIcon onClick={() => {
                  return showReassessmentListModal(site)
                }}>
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffsetAssessment] }}
                    overlay={{ label: 'assessmentsHint' }}
                    numberOfSites={site.SitesHistories?.length}
                    type='small'
                  >
                    <div>
                      <AssessmentIcon />
                    </div>
                  </Tooltip>
                </SiteTableAssessmentIcon>
              )}
            </div>
            <ActionsMenu dropdownItems={dropdownItems} />
          </SitesTableIconsWrapper>
        )

      } : {
        id: site.id,
        historyId: site.historyId,
        siteStatusId: site.SiteStatus?.id,
        country: displayCountry(site.SiteDetailsCountryId),
        siteId: site.siteCode,
        siteName: renderWithTooltip(site.name, SITE_NAME_MAX_LENGTH),
        year: site.year,
        proposer: renderWithTooltip(site.User ? `${capitalizeString(site.User.lastName || '')} ${capitalizeString(site.User.firstName || '')}` : 'Unknown', PROPOSER_MAX_LENGTH),
        siteStatus: (
          <>
            {site.SiteStatus?.name && renderSitesStatusIcon(site.SiteStatus.name)}
            {site.SiteStatus.id === SITE_STATUS_REVIEWED_BY_RFP_ID
              ? 'Reviewed by RFP'
              : capitalizeString(site.SiteStatus.name)}
          </>
        ),
        kbaClassification: site.KbaClassification?.name || '-',
        siteCriteria: (site.siteCriterias && site.siteCriterias.length > 0) ? site.siteCriterias.sort((a, b) => {
          if (a < b) {
            return -1
          }
          if (a > b) {
            return 1
          }

          return 0
        }).join(', ') : '-',
        ibaStatus: hasIBAAccessForRow
          ? renderSitesStatusUnderAssessment(
            shouldShowSiteIBAData(site, site.IbaStatus?.id || site.IbaStatusHistory?.id, 'sitesManagement')
          )
          : null,
        ibaCriteria: hasIBAAccessForRow ? shouldShowSiteIBAData(site,
          site.ibaCriterias && site.ibaCriterias.length > 0 ? site.ibaCriterias.sort((a, b) => {
            if (a < b) {
              return -1
            }
            if (a > b) {
              return 1
            }
            return 0
          }).join(', ') : null,
          'sitesManagement'
        ) : null,
        actions: (
          <SitesTableIconsWrapper>
            <div style={{ width: '24px' }}>
              {(site.SitesHistories?.length !== 0 && (site.SiteStatus?.id === SITE_STATUS_CONFIRMED_ID ||
                site.SiteStatus?.id === SITE_STATUS_DELISTED_ID ||
                site.SiteStatus?.id === SITE_STATUS_DOES_NOT_QUALIFY)) && (
                  <SiteTableAssessmentIcon onClick={() => {
                    return showReassessmentListModal(site)
                  }}>
                    <Tooltip
                      style={{ zIndex: 1000 }}
                      placement='top'
                      trigger={['hover']}
                      align={{ offset: [tooltipXOffset, tooltipYOffsetAssessment] }}
                      overlay={{ label: 'assessmentsHint' }}
                      numberOfSites={site?.SitesHistories?.length}
                      type='small'
                    >
                      <div>
                        <AssessmentIcon />
                      </div>
                    </Tooltip>
                  </SiteTableAssessmentIcon>
                )}
            </div>
            <ActionsMenu dropdownItems={dropdownItems} />
          </SitesTableIconsWrapper>
        )
      }
    })
  }
  return []
}

export const makeSitesColumns = (sorting, setSorting, isMySite, profile) => {
  // Check if user has IBA access using the new hook
  const { canSeeIBASitesManagement } = useIBAAccess()
  
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }


  const sortBySiteName = () => {
    sortFunction('name')
  }

  const sortByYear = () => {
    sortFunction('year')
  }

  const sortBySiteCode = () => {
    sortFunction('siteCode')
  }

  const sortByProposer = () => {
    sortFunction('ProposerId')
  }

  const sortBySiteStatus = () => {
    sortFunction('SiteStatusId')
  }

  const sortBySiteAssessmentStatus = () => {
    sortFunction('SiteStatusId')
  }

  const headers = [
    {
      id: 'country',
      header: (
        <>
          <FormattedMessage id='country' />
        </>
      ),
      accessorKey: 'country',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteName' />
          <SortingArrow
            onChange={sortBySiteName}
            checked={sorting.sortBy === 'name' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      size: 15, //reduced column size
      style: {
        maxWidth: '400px',
        minWidth: '60px',
        width: '250px'
      },
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteId',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteId' />
          <SortingArrow
            onChange={sortBySiteCode}
            checked={sorting.sortBy === 'siteCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteId',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'year',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='year' />
          <SortingArrow
            onChange={sortByYear}
            checked={sorting.sortBy === 'year' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'year',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'proposer',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='lastProposer' />
          <SortingArrow
            onChange={sortByProposer}
            checked={sorting.sortBy === 'ProposerId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'proposer',
      style: {
        maxWidth: '300px',
        minWidth: '100px',
        width: '150px'
      },
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteStatus',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaStatus' />
          <SortingArrow
            onChange={sortBySiteStatus}
            checked={sorting.sortBy === 'SiteStatusId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteStatus',
      style: {
        maxWidth: '300px',
        minWidth: '150px',
        width: '200px'
      },
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteCriteria',
      header: (
        <>
          <FormattedMessage id='kbaCriteria' />
        </>
      ),
      accessorKey: 'siteCriteria',
      cell: ({ getValue }) => getValue()
    },
    ...(canSeeIBASitesManagement ? [
      {
        id: 'ibaStatus',
        header: (
          <>
            <FormattedMessage id='ibaStatus' />
          </>
        ),
        accessorKey: 'ibaStatus',
        cell: ({ getValue }) => getValue()
      },
      {
        id: 'ibaCriteria',
        header: (
          <>
            <FormattedMessage id='ibaCriteria' />
          </>
        ),
        accessorKey: 'ibaCriteria',
        cell: ({ getValue }) => getValue()
      }
    ] : []),
    {
      id: 'actions',
      header: <FormattedMessage id='actions' />,
      accessorKey: 'actions',
      style: {
        width: '5%'
      },
      cell: ({ getValue }) => getValue()
    }
  ]

  if (isMySite) {
    // Insert Assessment column before Actions (after IBA columns)
    const actionsIndex = headers.findIndex(header => header.accessorKey === 'actions')
    const insertIndex = actionsIndex !== -1 ? actionsIndex : headers.length
    
    headers.splice(insertIndex, 0, {
      id: 'assessment',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='assessment' />
          <SortingArrow
            onChange={sortBySiteAssessmentStatus}
            checked={sorting.sortBy === 'SiteStatusId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'assessment',
      cell: ({ getValue }) => getValue()
    })
  } else {
    // Add KBA classification field for non-My sites view, after KBA status
    const kbaStatusIndex = headers.findIndex(header => header.accessorKey === 'siteStatus')
    if (kbaStatusIndex !== -1) {
      headers.splice(kbaStatusIndex + 1, 0, {
        id: 'kbaClassification',
        header: (
          <>
            <FormattedMessage id='kbaClassification' />
          </>
        ),
        accessorKey: 'kbaClassification',
        style: {
          maxWidth: '300px',
          minWidth: '150px',
          width: '200px'
        },
        cell: ({ getValue }) => getValue()
      })
    }
  }

  return headers
}
